import React from 'react';

import { HomeIcon } from '@heroicons/react/20/solid';

interface Props {
  breadcrumbs: {
    label: string;
    onClick?: () => void;
  }[];
  homeOnClick?: () => void;
}

export const Breadcrumbs = ({ homeOnClick, breadcrumbs }: Props) => {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex w-full space-x-4 overflow-scroll bg-gray-50 px-2">
        {homeOnClick && (
          <li className="px-4 py-3">
            <HomeIcon
              onClick={homeOnClick}
              className="h-5 w-5 flex-shrink-0 cursor-pointer text-slate-900 hover:text-slate-700"
              aria-hidden="true"
            />
          </li>
        )}
        {breadcrumbs.map((page, i) => (
          <li key={page.label + i} className="flex">
            <p
              onClick={page.onClick}
              className="cursor-pointer whitespace-nowrap px-4 py-3 text-sm font-medium text-slate-900 hover:text-slate-700"
            >
              {page.label}
            </p>
          </li>
        ))}
      </ol>
    </nav>
  );
};
